import { type BaseEntity } from "@/shared/types";
import { z } from "zod";

export interface EventType extends BaseEntity {
  tenant_id: string;
  name: string;
  color?: string;
}

// GraphQL Response Types
export interface EventTypeResponse {
  eventType: {
    id: string;
    accountId: string;
    name: string;
    color?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    deletedAt?: string | null;
    account?: {
      id: string;
      name: string;
    };
  };
}

export interface EventTypesResponse {
  eventTypes: {
    data: Array<{
      id: string;
      accountId: string;
      name: string;
      color?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      deletedAt?: string | null;
    }>;
    total: number;
    page: number;
    limit: number;
  };
}

export interface AllEventTypesResponse {
  allEventTypes: Array<{
    id: string;
    accountId: string;
    name: string;
    color?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    deletedAt?: string | null;
    account?: {
      id: string;
      name: string;
    };
  }>;
}

// REST API response types (for mutations)
export interface RESTEventType {
  id: string;
  accountId: string;
  name: string;
  color?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  deletedAt?: string | null;
}

// REST Input Types
export interface CreateEventTypeInput {
  name: string;
}

export interface UpdateEventTypeInput {
  name?: string;
  color?: string;
}

// Form Schema
export const eventTypeFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "common:validation.nameRequired")
    .max(100, "common:validation.nameMaxLength100"),
  color: z.string().optional().nullable(),
});

export type EventTypeFormData = z.infer<typeof eventTypeFormSchema>;

